import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { isNil } from 'lodash-es';
import { selectCsrfToken, selectUserSelectedRestaurantId } from './shared/selectors/auth.selectors';
import { IStoreState } from './types';
import { selectJwtToken } from './auth/selectors';

export const api = createApi({
	reducerPath: 'api',
	baseQuery: fetchBaseQuery({
		baseUrl: `${process.env.REACT_APP_SERVER_ENDPOINT}/api`,
		credentials: 'include',
		prepareHeaders: (headers, { getState }) => {
			const restaurantId = selectUserSelectedRestaurantId(<IStoreState>getState());
			const jwtToken = selectJwtToken(<IStoreState>getState());
			const csrfToken = selectCsrfToken(<IStoreState>getState());

			if (!isNil(jwtToken)) {
				headers.set('Authorization', `Bearer ${jwtToken}`);
			}

			if (!isNil(csrfToken) && !headers.has('Authorization')) {
				headers.set('X-CSRF-Token', csrfToken);
			}

			if (!isNil(restaurantId)) {
				headers.set('restaurant-id', restaurantId);
			}
		},
		paramsSerializer: (params) => {
			if (!params) {
				return '';
			}

			const query = new URLSearchParams();

			Object.entries(params).forEach(([key, value]) => {
				if (Array.isArray(value)) {
					// Since URLSearchParams doesn't really support arrays, we need to append every array item separately
					value.forEach((item) => query.append(key, item));
				} else {
					query.append(key, value);
				}
			});

			return decodeURIComponent(query.toString());
		},
	}),
	tagTypes: [],
	endpoints: () => ({}),
});

export const {
	util: { invalidateTags },
} = api;
